// Source: app/scripts/controllers/edit-general-case.js
Auction.controller('EditGeneralCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  '$route',
  '$timeout',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'ModalScrollLock',
  function ($scope, $filter, $routeParams, $location, $route, $timeout, toaster, crudService, $modal, Downloader, Messages, ModalScrollLock) {

    var caseService = crudService('general_cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/general_cases/:id'
      },
      'editGeneralCase': {
        method: 'POST',
        url: '/data/rest/general_cases/edit_general_case'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitGeneralCase': {
        method: 'POST',
        url: '/data/rest/general_cases/submit_general_case'
      }
    });


    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );
    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsTab = rt;
      // $location.search(search);
    };


    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsDocumentTab = rt;
      // $location.search(search);
    };


    function initEntity() {

      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {
        portalCase = data;
        if(portalCase.caseStatus != 'DRAFT' && portalCase.caseStatus != 'RETURNED_FOR_CORRECTIONS'){
          $scope.viewGeneralCase(portalCase.id);
        }
        $scope.allowEdit = true;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};

        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;
          // $location.path("/web_portal/web_portal_home_page/create_general_case");
        }
        $scope.activateTab(1);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;


            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
          });

        });
      });
      });

    }


    initEntity();


    $scope.editCase = function (portalCase) {
      caseService.editGeneralCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };


    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });
    $scope.modalSubmitCaseConfirm = $modal({
      scope: $scope,
      // title: $filter('translate')('portal.forum'),
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
    });


    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditCaseDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.outgoingDocumentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };


    $scope.deletePortalDocument = function () {
      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.outgoingDocumentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (id) {

      caseService.submitGeneralCase(id, function (data) {
        Messages.saved();
        $scope.modalSubmitCaseConfirm.hide();
        ModalScrollLock.release();
        $location.path("/web_portal/web_portal_home_page/view_general_case/" + id);
        $timeout(function () {
          ModalScrollLock.release();
          $route.reload();
        });
      });

    };

    $scope.viewGeneralCase = function (id) {
      $location.path("/web_portal/web_portal_home_page/view_general_case/" + id);
    };


  }
]);
